<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="header_main">
          <div class="header_title">
            {{ itemdata.name }}（适用于品牌方和工厂企业）
          </div>
        </div>
        <div class="content_main">
          <div class="content_main_title">
            {{ type == 1 ? "参选产品详情" : "参选评奖详情" }}
          </div>
          <!-- 货架好物报名模版表单 || 选品对接会报名模版表单 -->
          <template
            v-if="templateTpye == 1 || templateTpye == 2 || templateTpye == 3"
          >
            <el-form
              :model="shelfGoodsRuleForm"
              :rules="shelfGoodsRules"
              ref="shelfGoodsRuleForm"
              label-width="180px"
              class="demo-ruleForm"
              label-position="top"
            >
              <el-row>
                <el-col :span="8">
                  <el-form-item label="产品名称：" prop="goodsName">
                    <el-input
                      :disabled="type == 1 ? false : true"
                      v-model="shelfGoodsRuleForm.goodsName"
                      placeholder="请输入产品名称"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!--<el-col :span="8">-->
                <!--<el-form-item label="产品类别：" prop="changeproductClass">-->
                <!--<el-cascader   @change="handleChange"  :disabled="type==1?false:true"    v-model="shelfGoodsRuleForm.changeproductClass" style="width: 100%;" :options="productClass" :show-all-levels="false"></el-cascader>-->
                <!--</el-form-item>-->
                <!--</el-col>-->
                <el-col :span="8">
                  <el-form-item label="上市时间：" prop="market_time_new">
                    <el-date-picker
                      :disabled="type == 1 ? false : true"
                      style="width: 100%"
                      v-model="shelfGoodsRuleForm.market_time_new"
                      type="date"
                      :picker-options="pickeroptions0"
                      placeholder="选择上市时间"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    label="产品年销售额(单位:万元)："
                    prop="yearSale"
                  >
                    <el-input
                      :disabled="type == 1 ? false : true"
                      v-model="shelfGoodsRuleForm.yearSale"
                      placeholder="仅做渠道对接参考，不对外公布"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="产品零售价(单位:元)："
                    prop="retail_price"
                  >
                    <el-input
                      :disabled="type == 1 ? false : true"
                      v-model="shelfGoodsRuleForm.retail_price"
                      placeholder="仅做渠道对接参考，不对外公布"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    label="目前已有主要销售渠道："
                    prop="sales_channel"
                  >
                    <el-input
                      :disabled="type == 1 ? false : true"
                      v-model="shelfGoodsRuleForm.sales_channel"
                      placeholder="仅做渠道对接参考，不对外公布"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="希望开拓销售渠道："
                    prop="expand_channels"
                  >
                    <el-input
                      :disabled="type == 1 ? false : true"
                      v-model="shelfGoodsRuleForm.expand_channels"
                      placeholder="仅做渠道对接参考，不对外公布"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="产品简介：" prop="introduction">
                    <el-input
                      :disabled="type == 1 ? false : true"
                      type="textarea"
                      v-model="shelfGoodsRuleForm.introduction"
                      rows="4"
                      resize="none"
                      placeholder="须包含与同类产品差异化特点或卖点"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="产品图片："
                    prop="imgs"
                    class="form-width"
                  >
                    <div class="image" v-if="shelfGoodsRuleForm.imgs">
                      <el-image
                        :src="$imgOssUrl + shelfGoodsRuleForm.imgs"
                      ></el-image>
                      <div class="upload-span">
                        <span
                          class="upload-icon"
                          @click.stop="
                            handlePictureCardPreview(
                              $imgOssUrl + shelfGoodsRuleForm.imgs
                            )
                          "
                          ><i class="el-icon-zoom-in"></i
                        ></span>
                        <span
                          v-if="type == 1"
                          class="upload-icon"
                          @click.stop="handlecpRemove()"
                          style="margin-left: 20px"
                          ><i class="el-icon-delete"></i
                        ></span>
                      </div>
                    </div>
                    <div v-if="!shelfGoodsRuleForm.imgs">
                      <el-upload
                        :action="$Url"
                        list-type="picture-card"
                        :headers="headers"
                        :multiple="false"
                        :on-progress="handleProgressCp"
                        :on-success="handlecpSuccess"
                        :on-error="handlecpError"
                        :show-file-list="false"
                      >
                        <i class="el-icon-plus" v-if="!progressCpVisible"></i>
                        <div v-if="progressCpVisible" style="padding-top: 30px">
                          <el-progress
                            :percentage="progressCpPercent"
                            type="circle"
                            :width="80"
                          ></el-progress>
                        </div>
                      </el-upload>
                    </div>
                    <div class="img-tips">
                      上传图片接受JPG、PNG格式、图片大小不超过2M,分辨率不小于300dpl
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <!--<el-row>-->
              <!--<el-col :span="12">-->
              <!--<el-form-item label="" prop="up_suggestarr">-->
              <!--<span style="color: red;">* </span>货架选择 <span style="color: red;">(请选择最匹配的货架场景，仅限选一项，货架名额满后，主办方将根据货架情况调剂)</span>-->
              <!--<div v-for="(items,index) in dictData.up_suggest" :key="index">-->
              <!--<el-col  :span="24">{{ index }}</el-col>-->
              <!--<el-checkbox-group  :disabled="type==1?false:true" v-model="shelfGoodsRuleForm.up_suggestarr"  @change="handleselectionChange">-->
              <!--<el-checkbox v-for="(item,idx) in items" :key="idx" :label="item">{{ item }}</el-checkbox>-->
              <!--</el-checkbox-group>-->
              <!--</div>-->
              <!--<el-col :span="24"><el-checkbox  :disabled="type==1?false:true" v-model="shelfGoodsRuleForm.up_suggestarr" @change="handleselectionChange" label="其他"></el-checkbox>:(以上都没有，请详细填写)</el-col>-->
              <!--<el-input :disabled="type==1?false:true" v-model="hjxz"  v-if="shelfGoodsRuleForm.up_suggestarr.includes('其他')"  placeholder="以上都没有，请详细填写"></el-input>-->
              <!--</el-form-item>-->
              <!--</el-col>-->
              <!--</el-row>-->
              <el-row>
                <el-col :span="12">
                  <el-form-item label="" prop="up_suggest1">
                    <span style="color: red">* </span>货架选择：<span
                      style="color: red"
                      >(请选择最匹配的货架场景，仅限选一项，货架名额满后，主办方将根据货架情况调剂)</span
                    >

                    <el-radio-group v-model="shelfGoodsRuleForm.up_suggest1">
                      <el-radio
                        :disabled="type == 1 ? false : true"
                        v-for="(item, index) in dictData.up_suggest"
                        :key="index"
                        :label="item"
                        >{{ item }}</el-radio
                      >
                    </el-radio-group>

                    <el-col :span="24"
                      ><el-radio
                        :disabled="type == 1 ? false : true"
                        v-model="shelfGoodsRuleForm.up_suggest1"
                        label="其他"
                      ></el-radio
                      >:(以上都没有，请详细填写)</el-col
                    >
                    <el-input
                      v-model="hjxz"
                      :disabled="type == 1 ? false : true"
                      v-if="shelfGoodsRuleForm.up_suggest1 == '其他'"
                      placeholder="以上都没有，请详细填写"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!--极智工场报名  表单-->
              <template v-if="templateTpye == 3">

                <el-row>
                  <el-col :span="16">
                    <el-form-item label="可生产剂型" prop="used_dosagearr">
                      <el-checkbox-group
                        :disabled="type == 1 ? false : true"
                        v-model="shelfGoodsRuleForm.used_dosagearr"
                      >
                        <el-checkbox
                          v-for="(item, index) in dictData.used_dosage"
                          :key="index"
                          :label="item"
                        ></el-checkbox>
                      </el-checkbox-group>
                      <el-col :span="24"
                        ><el-checkbox
                          :disabled="type == 1 ? false : true"
                          v-model="shelfGoodsRuleForm.used_dosagearr"
                          label="其他"
                        ></el-checkbox
                        >:(以上都没有，请详细填写)</el-col
                      >
                      <el-input
                        :disabled="type == 1 ? false : true"
                        v-model="scjx"
                        v-if="
                          shelfGoodsRuleForm.used_dosagearr.includes('其他')
                        "
                        placeholder="以上都没有，请详细填写"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item label="是否进口：" prop="is_import">
                      <el-radio-group
                        v-model="shelfGoodsRuleForm.is_import"
                        :disabled="type == 1 ? false : true"
                      >
                        <el-radio
                          v-for="(item, index) in dictData.is_import"
                          :key="index"
                          :label="item"
                          >{{ item }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="目前主要合作客户：" prop="partnership">
                      <el-input
                        :disabled="type == 1 ? false : true"
                        v-model="shelfGoodsRuleForm.partnership"
                        placeholder="请输入目前主要合作客户"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!--<el-row>-->
                <!--<el-col :span="16">-->
                <!--<el-form-item label="" prop="solutionarr">-->
                <!--<span style="color: red;">* </span>解决方案： <span style="color: red;">可多选（最多限选3项）</span>-->
                <!--<div v-for="(items,index) in dictData.solution" :key="index">-->
                <!--<el-col :span="24">{{ index }}:</el-col>-->
                <!--<el-checkbox-group :disabled="type==1?false:true" v-model="shelfGoodsRuleForm.solutionarr" >-->
                <!--<el-checkbox    v-for="(item,idx) in items" :key="idx" :label="item"></el-checkbox>-->
                <!--</el-checkbox-group>-->
                <!--</div>-->
                <!--<el-col :span="24"><el-checkbox :disabled="type==1?false:true" v-model="shelfGoodsRuleForm.solutionarr"   label="其他"></el-checkbox>:(以上都没有，请详细填写)</el-col>-->
                <!--<el-input :disabled="type==1?false:true" v-model="jjfa" v-if="shelfGoodsRuleForm.solutionarr.includes('其他')"  placeholder="以上都没有，请详细填写"></el-input>-->
                <!--</el-form-item>-->
                <!--</el-col>-->
                <!--</el-row>-->
                <el-row>
                  <el-col :span="16">
                    <el-form-item label="" prop="solutionarr">
                      <span style="color: red">* </span>解决方案：
                      <span style="color: red">可多选（最多限选3项）</span>
                      <el-checkbox-group
                        v-model="shelfGoodsRuleForm.solutionarr"
                        @change="handlesolutionChange"
                      >
                        <el-checkbox
                          v-for="(item, index) in dictData.solution"
                          :key="index"
                          :label="item"
                        ></el-checkbox>
                      </el-checkbox-group>
                      <el-col :span="24"
                        ><el-checkbox
                          v-model="shelfGoodsRuleForm.solutionarr"
                          @change="handlesolutionChange"
                          label="其他"
                        ></el-checkbox
                        >:(以上都没有，请详细填写)</el-col
                      >
                      <el-input
                        v-model="jjfa"
                        v-if="shelfGoodsRuleForm.solutionarr.includes('其他')"
                        placeholder="以上都没有，请详细填写"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">
                    <el-form-item
                      label="可提供制造加工的剂型和产品形态："
                      prop="provide_used_dosagearr"
                    >
                      <el-checkbox-group
                        :disabled="type == 1 ? false : true"
                        v-model="shelfGoodsRuleForm.provide_used_dosagearr"
                      >
                        <el-checkbox
                          v-for="(item, index) in dictData.provide_used_dosage"
                          :key="index"
                          :label="item"
                        ></el-checkbox>
                      </el-checkbox-group>
                      <el-col :span="24"
                        ><el-checkbox
                          :disabled="type == 1 ? false : true"
                          v-model="shelfGoodsRuleForm.provide_used_dosagearr"
                          label="其他"
                        ></el-checkbox
                        >:(以上都没有，请详细填写)</el-col
                      >
                      <el-input
                        :disabled="type == 1 ? false : true"
                        v-model="cpxt"
                        v-if="
                          shelfGoodsRuleForm.used_dosagearr.includes('其他')
                        "
                        placeholder="以上都没有，请详细填写"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label="产品或解决方案图片"
                      prop="solution_images"
                      class="form-width"
                    >
                      <div style="display: flex">
                        <div
                          class="image-wrap"
                          v-if="shelfGoodsRuleForm.solution_images"
                        >
                          <div
                            class="image"
                            v-for="(
                              item, index
                            ) in shelfGoodsRuleForm.solution_images"
                            :key="item.url"
                          >
                            <el-image :src="$imgOssUrl + item.url"></el-image>
                            <div class="upload-span">
                              <span
                                class="upload-icon"
                                @click.stop="
                                  handlePictureCardPreview(
                                    $imgOssUrl + item.url
                                  )
                                "
                                ><i class="el-icon-zoom-in"></i
                              ></span>
                              <span
                                v-if="type == 1"
                                class="upload-icon"
                                @click.stop="handleImgRemove(index)"
                                style="margin-left: 20px"
                                ><i class="el-icon-delete"></i
                              ></span>
                            </div>
                          </div>
                        </div>

                        <div
                          v-if="shelfGoodsRuleForm.solution_images.length < 3"
                        >
                          <el-upload
                            :action="$Url"
                            list-type="picture-card"
                            :headers="headers"
                            :multiple="false"
                            :on-progress="handleProgressImgs"
                            :on-success="handleImgsSuccess"
                            :on-error="handleImgsError"
                            :show-file-list="false"
                          >
                            <i class="el-icon-plus" v-if="!progressImgsVisible"></i>
                            <div v-if="progressImgsVisible" style="padding-top: 30px">
                              <el-progress
                                      :percentage="progressImgsPercent"
                                      type="circle"
                                      :width="80"
                              ></el-progress>
                            </div>
                          </el-upload>
                        </div>
                      </div>
                      <div class="img-tips">
                        上传图片接受JPG、PNG格式、图片大小不超过2M,分辨率不小产品年销售额(单位:万元)：于300dpl
                      </div>
                    </el-form-item>
                    <!-- <el-form-item label="产品图片：" prop="imgs">
                                            <el-upload
                                              class="tp_update"
                                              action="/kindeditor/php/uploadApi.php?mode=3"
                                              name='imgFile'
                                              :on-success="handleAvatarPictureSuccess"
                                              list-type="picture-card"
                                              :show-file-list="false"

                                          >
                                              <img v-if="cpImgList[0]" :src="Imghttp + cpImgList[0]" class="avatar">
                                              <div class="upload-tip" v-else>
                                                  <i class="el-icon-plus">
                                                      <p class="el-icon-tip">请上传高清图片</p>
                                                  </i>
                                              </div>
                                          </el-upload>
                                  </el-form-item> -->
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">
                    <el-form-item
                      label="希望开发的客户类型："
                      prop="hope_customerarr"
                    >
                      <el-checkbox-group
                        :disabled="type == 1 ? false : true"
                        v-model="shelfGoodsRuleForm.hope_customerarr"
                      >
                        <el-checkbox
                          v-for="(item, index) in dictData.hope_customer"
                          :key="index"
                          :label="item"
                        ></el-checkbox>
                      </el-checkbox-group>
                      <el-col :span="24"
                        ><el-checkbox
                          :disabled="type == 1 ? false : true"
                          v-model="shelfGoodsRuleForm.hope_customerarr"
                          label="其他"
                        ></el-checkbox
                        >:(以上都没有，请详细填写)</el-col
                      >
                      <el-input
                        v-model="khlx"
                        :disabled="type == 1 ? false : true"
                        v-if="
                          shelfGoodsRuleForm.hope_customerarr.includes('其他')
                        "
                        placeholder="以上都没有，请详细填写"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">
                    <el-form-item label="是否自有工厂：" prop="is_factory">
                      <el-radio-group
                        :disabled="type == 1 ? false : true"
                        v-model="shelfGoodsRuleForm.is_factory"
                      >
                        <el-radio
                          v-for="(item, index) in dictData.is_factory"
                          :key="index"
                          :label="item"
                          >{{ item }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item
                      label="是否有海外工厂："
                      prop="is_overseas_factory"
                    >
                      <el-radio-group
                        :disabled="type == 1 ? false : true"
                        v-model="shelfGoodsRuleForm.is_overseas_factory"
                      >
                        <el-radio
                          v-for="(item, index) in dictData.is_overseas_factory"
                          :key="index"
                          :label="item"
                          >{{ item }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="16">
                    <el-form-item label="是否自有原料：" prop="goodsName">
                      <el-radio-group
                        :disabled="type == 1 ? false : true"
                        v-model="shelfGoodsRuleForm.is_self_materials"
                      >
                        <el-radio
                          v-for="(item, index) in dictData.is_self_materials"
                          :key="index"
                          :label="item"
                          >{{ item }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item
                      label="是否能根据客户需求提供解决方案："
                      prop="provide_solution"
                    >
                      <el-radio-group
                        :disabled="type == 1 ? false : true"
                        v-model="shelfGoodsRuleForm.provide_solution"
                      >
                        <el-radio
                          v-for="(item, index) in dictData.provide_solution"
                          :key="index"
                          :label="item"
                          >{{ item }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="16">
                    <el-form-item
                      label="是否有30天推出新品的能力："
                      prop="push_new_product"
                    >
                      <el-radio-group
                        :disabled="type == 1 ? false : true"
                        v-model="shelfGoodsRuleForm.push_new_product"
                      >
                        <el-radio
                          v-for="(item, index) in dictData.push_new_product"
                          :key="index"
                          :label="item"
                          >{{ item }}</el-radio
                        >
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <!-- 选品对接会报名 表单 -->
              <template v-if="templateTpye == 2 && type == 2">
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label="请选择您希望参加的对接会场次"
                      prop="match_making"
                    >
                      <el-checkbox-group
                        :disabled="type == 1 ? false : true"
                        v-model="shelfGoodsRuleForm.match_making"
                      >
                        <el-checkbox
                          v-for="(item, index) in dictData.match_making"
                          :key="index"
                          :label="item"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>

              <el-row v-if="type == 1">
                <el-form-item class="save_btn">
                  <el-button @click="goback">返 回</el-button>
                  <el-button
                    type="primary"
                    @click="submitForm('shelfGoodsRuleForm', 1)"
                    :disabled="disableds"
                    >保存</el-button
                  >
                </el-form-item>
              </el-row>
            </el-form>
          </template>

          <el-dialog :visible.sync="dialogVisible">
            <img style="max-height: 500px;max-width: 100%;width: auto;margin: 0 auto;" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  nhneMarketProductdetail,
  marketNhneDict,
  getEnrollProductDetail,
  editnhneMarketProduct,
} from "@/api/api";
import "../../style/base.css";
import top from "../../components/top.vue"; //头部
import navMenu from "../../components/navMenu.vue"; //左侧步骤条
export default {
  name: "productawardDetail",
  components: { top, navMenu },
  data() {
    return {
      data: {},
      Imghttp: "https://oss.larspring.com/pharmchina",
      cpFileList: [], // 产品配料表
      cpImgsFileList: [], // 产品图片
      zjImgsFileList: [], //质检图片
      fmImgsFileList: [], // 发明
      lsImgsFileList: [], //历史
      loading: false,
      dialogImageUrl: "", // 预览图片
      dialogVisible: false, //预览弹框
      templateTpye: "", //  1货架好物模版表单 2 选品对接会报名模版表单  3 极智工场报名模版表单
      shelfGoodsRuleForm: {
        up_suggest1: "",
        changeproductClass: [],
        goodsName: "", //产品图片
        productClass: "", //产品类别
        imgs: "",
        sales_channel: "",
        retail_price: "",
        // up_suggestarr:[],
        up_suggest: "",
        producible_dosage: "",
        expand_channels: "",
        market_time_new: "",
        market_time: "",
        solutionarr: [],
        solution: "",
        used_dosagearr: [],
        used_dosage: "",
        solution_images: [],
        solution_image: "",
        partnership: "",
        hope_customer: "",
        hope_customerarr: [],
        is_factory: "",
        is_overseas_factory: "",
        is_self_materials: "",
        provide_solution: "",
        push_new_product: "",
        yearSale: "",
        provide_used_dosage: "",
        provide_used_dosagearr: [],
        introduction: "",
        is_import: "",
        match_making: [],
      },
      dictData: {},
      id: "",
      itemdata: {},
      shelfGoodsRules: {
        goodsName: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        changeproductClass: [
          { required: true, message: "请输入产品类别", trigger: "blur" },
        ],
        market_time_new: [
          {
            type: "date",
            required: true,
            message: "请选择上市时间",
            trigger: "change",
          },
        ],
        yearSale: [
          { required: true, message: "请输入产品年销售额", trigger: "blur" },
        ],
        retail_price: [
          { required: true, message: "请输入产品零售价", trigger: "blur" },
        ],
        sales_channel: [
          {
            required: true,
            message: "请输入目前已有主要销售渠道",
            trigger: "blur",
          },
        ],
        expand_channels: [
          {
            required: true,
            message: "请输入希望开拓销售渠道",
            trigger: "blur",
          },
        ],
        introduction: [
          { required: true, message: "请输入产品简介", trigger: "blur" },
        ],
        imgs: [{ required: true, message: "请上传产品图片", trigger: "blur" }],
        up_suggest1: [
          { required: true, message: "请选择货架选择", trigger: "change" },
        ],
        used_dosagearr: [
          {
            type: "array",
            required: true,
            message: "请选择可生产剂型",
            trigger: "change",
          },
        ],
        is_import: [
          { required: true, message: "请选择是否进口", trigger: "change" },
        ],
        partnership: [
          { required: true, message: "请选择是否进口", trigger: "blur" },
        ],
        solutionarr: [
          {
            type: "array",
            required: true,
            message: "请选择解决方案",
            trigger: "change",
          },
        ],
        provide_used_dosagearr: [
          {
            type: "array",
            required: true,
            message: "请选择可提供制造加工的剂型和产品形态",
            trigger: "change",
          },
        ],
        solution_images: [
          {
            type: "array",
            required: true,
            message: "请上传产品或解决方案图片",
            trigger: "change",
          },
        ],
        hope_customerarr: [
          {
            type: "array",
            required: true,
            message: "请选择希望开发的客户类型",
            trigger: "change",
          },
        ],
        is_factory: [
          { required: true, message: "请选择是否自有工厂", trigger: "blur" },
        ],
        is_overseas_factory: [
          { required: true, message: "请选择是否有海外工厂", trigger: "blur" },
        ],
        is_self_materials: [
          { required: true, message: "请选择是否自有原料", trigger: "blur" },
        ],
        provide_solution: [
          {
            required: true,
            message: "请选择是否能根据客户需求提供解决方案",
            trigger: "blur",
          },
        ],
        push_new_product: [
          {
            required: true,
            message: "请选择是否有30天推出新品的能力",
            trigger: "blur",
          },
        ],
      },
      type: "",

      productClass: [],
      hjxz: "",
      scjx: "",
      jjfa: "",
      cpxt: "",
      khlx: "",
      disableds: false,
      maxselectionSelections: 1,
      maxsolutionSelections: 3,
      token: {},
      pickeroptions0: {
        disabledDate(date) {
          if (!date) return false; // 如果日期为空，允许选择
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 设置为当天的00:00:00
          const tomorrow = new Date(today);
          tomorrow.setDate(today.getDate() + 1); // 计算明天的日期
          return date.getTime() >= tomorrow.getTime(); // 禁用明天及之后的日期
        },
      },
      progressCpVisible: false,
      progressCpPercent: 0,
        progressImgsVisible:false,
        progressImgsPercent:0
    };
  },
  created() {},

  mounted() {
    this.itemdata = JSON.parse(sessionStorage.getItem("itemdata"));
    this.dictData = JSON.parse(sessionStorage.getItem("dictData"));
    this.productClass = JSON.parse(sessionStorage.getItem("productClass"));
    console.log(this.dictData.match_making, "dictData");
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    this.templateTpye = this.itemdata.id;
    // this.getmarketNhneDict()
    this.getdetail();
  },
  methods: {

      handleProgressImgs(event, file, fileList) {
        console.log(event, "====event");
        // 显示进度条
        this.progressImgsVisible = true;
        // 计算进度百分比
        this.progressImgsPercent = Math.floor((event.loaded / event.total) * 100);
    },
    handleProgressCp(event, file, fileList) {
      console.log(event, "====event");
      // 显示进度条
      this.progressCpVisible = true;
      // 计算进度百分比
      this.progressCpPercent = Math.floor((event.loaded / event.total) * 100);
    },
    // // 货架选择 只能选择一项
    // handleselectionChange(value) {
    //     // 如果选择的项数超过最大限制
    //     if (this.shelfGoodsRuleForm.up_suggestarr.length > this.maxselectionSelections) {
    //         // 取出超出的项
    //         this.$message.error(`最多只能选择 ${this.maxselectionSelections} 项`);
    //
    //         // 使选项回到上一个合法状态
    //         this.shelfGoodsRuleForm.up_suggestarr = this.shelfGoodsRuleForm.up_suggestarr.slice(0, this.maxselectionSelections);
    //     }
    // },
    // 解决方案 只能选择三项
    handlesolutionChange() {
      // 如果选择的项数超过最大限制
      if (
        this.shelfGoodsRuleForm.solutionarr.length > this.maxsolutionSelections
      ) {
        // 取出超出的项
        this.$message.error(`最多只能选择 ${this.maxsolutionSelections} 项`);

        // 使选项回到上一个合法状态
        this.shelfGoodsRuleForm.solutionarr =
          this.shelfGoodsRuleForm.solutionarr.slice(
            0,
            this.maxsolutionSelections
          );
      }
    },
    handleChange(value) {
      this.shelfGoodsRuleForm.productClass = value[1];
    },
    goback() {
      this.$router.back();
    },
    //  仅保存 && 添加产品
    submitForm(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disableds = true;
          setTimeout(() => {
            this.disableds = false;
          }, 2000);

          const data = this.shelfGoodsRuleForm;

          data.up_suggest = data.up_suggest1;

          if (data.up_suggest == "其他") {
            // data.up_suggestarr = data.up_suggestarr.filter(item => item !== '其他');
            data.up_suggest = "#" + this.hjxz;
          }

          // console.log(data,"data")
          //
          // if(data.up_suggestarr.includes('其他')){
          //     data.up_suggestarr = data.up_suggestarr.filter(item => item !== '其他');
          //     data.up_suggestarr.push('#'+this.hjxz)
          // }
          if (data.used_dosagearr.includes("其他")) {
            data.used_dosagearr = data.used_dosagearr.filter(
              (item) => item !== "其他"
            );
            data.used_dosagearr.push("#" + this.scjx);
          }
          data.used_dosage = data.used_dosagearr.join(",");
          // data.up_suggest = data.up_suggestarr.join(',');
          data.market_time = moment(data.market_time_new).format("YYYY-MM-DD");

          if (data.productClass === "OEM") {
            if (data.solutionarr.includes("其他")) {
              data.solutionarr = data.solutionarr.filter(
                (item) => item !== "其他"
              );
              data.solutionarr.push("#" + this.jjfa);
            }
            if (data.hope_customerarr.includes("其他")) {
              data.hope_customerarr = data.hope_customerarr.filter(
                (item) => item !== "其他"
              );
              data.hope_customerarr.push("#" + this.khlx);
            }
            if (data.provide_used_dosagearr.includes("其他")) {
              data.provide_used_dosagearr = data.provide_used_dosagearr.filter(
                (item) => item !== "其他"
              );
              data.provide_used_dosagearr.push("#" + this.cpxt);
            }
            data.solution = data.solutionarr.join(",");
            data.hope_customer = data.hope_customerarr.join(",");
            data.provide_used_dosage = data.provide_used_dosagearr.join(",");
            data.solution_image = data.solution_images
              .map((item) => item.url)
              .join(",");
          }
          data.id = this.id;

          if (this.itemdata.id == 2) {
            data.match_making = data.match_making.join(",");
          }

          if (type === 1) {
            data.operation_type = 1;
          } else {
            if (this.itemdata.id == 1) {
              let marketTimeStatus = this.isProductAvailableAfterDate(
                new Date(data.market_time)
              );
              if (!marketTimeStatus) {
                this.$message.warning(
                  "参选产品仅支持2023年1月1日（包含）之后的产品"
                );
                return;
              }
            }
            // 提交报名信息
            data.operation_type = 2;
            data.awards_id = this.itemdata.id;
            data.awards_name = this.itemdata.name;
          }
          editnhneMarketProduct(this.$qs.stringify(data))
            .then((res) => {
              const msg = res.data.msg;
              if (res.data.code === 1) {
                this.$message.success(msg);
                this.goback();
              } else {
                this.$message.warning(msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 产品图片删除
    handlecpRemove(file, fileList) {
      this.shelfGoodsRuleForm.imgs = "";
    },
    handlecpSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      this.shelfGoodsRuleForm.imgs = resData.data.url;
      this.progressCpVisible = false;
    },
    // 产品图片上传失败
    handlecpError(err, file, fileList) {
      this.$message.error(err.message);
        this.progressCpVisible = false;
    },
    //产品或解决方案图片上传成功
    handleImgsSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      this.shelfGoodsRuleForm.solution_images.push({ url: resData.data.url });
      this.progressImgsVisible=false
    },
    // 产品或解决方案图片上传失败
    handleImgsError(err, file, fileList) {
      this.$message.error(err.message);
        this.progressImgsVisible=false
    },
    //产品或解决方案图片删除
    handleImgRemove(index) {
      this.shelfGoodsRuleForm.solution_images.splice(index, 1);
    },
    //预览图片
    handlePictureCardPreview(file) {
      console.log(file, "file");
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    processArray(arr, additionalOptions) {
      // 初始化结果数组
      const resultArray = [];

      // 初始化提取的选项数组
      const extractedOptions = [];

      // 遍历原始数组
      arr.forEach((item) => {
        // 判断字符串中是否包含 #
        const hashIndex = item.indexOf("#");

        if (hashIndex !== -1) {
          // 如果包含 #，提取 # 后的部分
          const extractedItem = item.slice(hashIndex + 1);
          extractedOptions.push(extractedItem);
        } else {
          // 不包含 # 的项添加到结果数组中
          resultArray.push(item);
        }
      });

      // 将其他选项添加到结果数组
      resultArray.push(...additionalOptions);

      return {
        resultArray,
        extractedOptions,
      };
    },
    //获取产品详情

    getdetail() {
      if (this.type == 1) {
        this.getnhneMarketProductdetail();
      } else if (this.type == 2) {
        this.getEnrollProductDetail();
      }
    },
    // 获取产品详情
    async getnhneMarketProductdetail() {
      const additionalOptions = ["其他"];
      try {
        const data = { id: this.id };
        const res = await nhneMarketProductdetail(data);

        if (res.data.code === 1) {
          console.log(res, "res====");

          const productData = res.data.data;
          this.shelfGoodsRuleForm.goodsName = productData.goodsName;

          const productClass = this.dictData.productClass || [];

          // 初始化结果数组
          let changeproductClass = [];

          // 遍历 productClass 对象的键
          for (const key in productClass) {
            if (
              productClass.hasOwnProperty(key) &&
              productClass[key].includes(productData.productClass)
            ) {
              changeproductClass.push(key, productData.productClass);
            }
          }

          // 更新 changeproductClass 的值
          this.shelfGoodsRuleForm.changeproductClass = changeproductClass;
          this.shelfGoodsRuleForm.productClass = changeproductClass[1];

          const marketTimeInSeconds = parseInt(
            new Date(productData.market_time).getTime()
          );

          Object.assign(this.shelfGoodsRuleForm, {
            productClass: productData.productClass,
            market_time_new: marketTimeInSeconds,
            market_time: productData.market_time,
            yearSale: productData.yearSale,
            retail_price: productData.retail_price,
            sales_channel: productData.sales_channel,
            expand_channels: productData.expand_channels,
            introduction: productData.introduction,
            used_dosage: productData.used_dosage,
            used_dosagearr: productData.used_dosage.split(","),
            up_suggest: productData.up_suggest,
            up_suggest1: productData.up_suggest,
            is_import: productData.is_import,
            imgs: productData.imgs,
          });
          let new_up_suggest = [];
          for (const key in this.dictData.up_suggest) {
            this.dictData.up_suggest.map((item) => {
              new_up_suggest.push(item);
            });
          }
          // this.shelfGoodsRuleForm.up_suggestarr = this.shelfGoodsRuleForm.up_suggestarr.filter(item =>  new Set(new_up_suggest).has(item) || this.startsWithHash(item) || item === '其他');

          // 可生产剂型
          this.shelfGoodsRuleForm.used_dosagearr =
            this.shelfGoodsRuleForm.used_dosagearr.filter(
              (item) =>
                new Set(this.dictData.used_dosage).has(item) ||
                this.startsWithHash(item) ||
                item === "其他"
            );

          // // 判断数组中是否包含以 # 开头的元素
          // const hasup_sugge = this.shelfGoodsRuleForm.up_suggestarr.some(item => item.startsWith('#'));
          // if(hasup_sugge){
          //     let up_suggest_new=this.processArray(this.shelfGoodsRuleForm.up_suggestarr, additionalOptions);
          //     this.shelfGoodsRuleForm.up_suggestarr=up_suggest_new.resultArray
          //     this.hjxz=up_suggest_new.extractedOptions[0]
          // }

          // 判断数组中是否包含包含 # 的元素
          const hasHash = this.shelfGoodsRuleForm.up_suggest.includes("#");

          if (hasHash) {
            this.hjxz = this.shelfGoodsRuleForm.up_suggest1.replace(/#/g, "");
            this.shelfGoodsRuleForm.up_suggest1 = "其他";
            console.log(this.hjxz, " this.hjxz");
          }

          const hasused_dosage = this.shelfGoodsRuleForm.used_dosagearr.some(
            (item) => item.startsWith("#")
          );
          if (hasused_dosage) {
            let used_dosage_new = this.processArray(
              this.shelfGoodsRuleForm.used_dosagearr,
              additionalOptions
            );
            this.shelfGoodsRuleForm.used_dosagearr =
              used_dosage_new.resultArray;
            this.scjx = used_dosage_new.extractedOptions[0];
          }

          if (productData.productClass === "OEM") {
            const solutionImages = productData.solution_image
              .split(",")
              .map((item) => ({ url: item }));

            Object.assign(this.shelfGoodsRuleForm, {
              partnership: productData.partnership,
              solution: productData.solution,
              solutionarr: productData.solution.split(","),
              hope_customer: productData.hope_customer,
              hope_customerarr: productData.hope_customer.split(","),
              provide_used_dosage: productData.provide_used_dosage,
              provide_used_dosagearr:
                productData.provide_used_dosage.split(","),
              solution_images: solutionImages,
              is_factory: productData.is_factory,
              is_overseas_factory: productData.is_overseas_factory,
              is_self_materials: productData.is_self_materials,
              provide_solution: productData.provide_solution,
              push_new_product: productData.push_new_product,
            });
            let new_solution = [];
            for (const key in this.dictData.solution) {
              this.dictData.solution[key].map((item) => {
                new_solution.push(item);
              });
            }
            this.shelfGoodsRuleForm.solutionarr =
              this.shelfGoodsRuleForm.solutionarr.filter(
                (item) =>
                  new Set(new_solution).has(item) ||
                  this.startsWithHash(item) ||
                  item === "其他"
              );

            this.shelfGoodsRuleForm.hope_customerarr =
              this.shelfGoodsRuleForm.hope_customerarr.filter(
                (item) =>
                  new Set(this.dictData.hope_customer).has(item) ||
                  this.startsWithHash(item) ||
                  item === "其他"
              );
            this.shelfGoodsRuleForm.provide_used_dosagearr =
              this.shelfGoodsRuleForm.provide_used_dosagearr.filter(
                (item) =>
                  new Set(this.dictData.provide_used_dosage).has(item) ||
                  this.startsWithHash(item) ||
                  item === "其他"
              );

            // 判断数组中是否包含以 # 开头的元素
            const hassolutionarr = this.shelfGoodsRuleForm.solutionarr.some(
              (item) => item.startsWith("#")
            );
            if (hassolutionarr) {
              let solution_new = this.processArray(
                this.shelfGoodsRuleForm.solutionarr,
                additionalOptions
              );
              this.shelfGoodsRuleForm.solutionarr = solution_new.resultArray;
              this.jjfa = solution_new.extractedOptions[0];
            }
            const hashope_customer =
              this.shelfGoodsRuleForm.hope_customerarr.some((item) =>
                item.startsWith("#")
              );
            if (hashope_customer) {
              let hope_customer_new = this.processArray(
                this.shelfGoodsRuleForm.hope_customerarr,
                additionalOptions
              );
              this.shelfGoodsRuleForm.hope_customerarr =
                hope_customer_new.resultArray;
              this.khlx = hope_customer_new.extractedOptions[0];
            }
            const hasprovide_used_dosage =
              this.shelfGoodsRuleForm.provide_used_dosagearr.some((item) =>
                item.startsWith("#")
              );
            if (hasprovide_used_dosage) {
              let provide_used_dosage_new = this.processArray(
                this.shelfGoodsRuleForm.provide_used_dosagearr,
                additionalOptions
              );
              this.shelfGoodsRuleForm.provide_used_dosagearr =
                provide_used_dosage_new.resultArray;
              this.cpxt = provide_used_dosage_new.extractedOptions[0];
            }
          }
        }
      } catch (err) {
        console.error("Error fetching product details:", err);
      }
    },
    startsWithHash(str) {
      return str.startsWith("#");
    },
    // 评奖详情
    async getEnrollProductDetail() {
      const additionalOptions = ["其他"];
      try {
        let data = { id: this.id, awards_id: this.itemdata.id };
        const res = await getEnrollProductDetail(this.$qs.stringify(data));

        if (res.data.code === 1) {
          console.log(res, "res====");

          const productData = res.data.data;
          this.shelfGoodsRuleForm.goodsName = productData.goodsName;

          const productClass = this.dictData.productClass || {};

          // 初始化结果数组
          let changeproductClass = [];

          // 遍历 productClass 对象的键
          for (const key in productClass) {
            if (
              productClass.hasOwnProperty(key) &&
              productClass[key].includes(productData.productClass)
            ) {
              changeproductClass.push(key, productData.productClass);
            }
          }

          // 更新 changeproductClass 的值
          this.$set(this, "changeproductClass", changeproductClass);
          this.loading = false;

          // const marketTimeInSeconds = parseInt(new Date(productData.market_time).getTime());
          let marketTimeInSeconds = "";
          if (
            productData.market_time == "" ||
            productData.market_time == null
          ) {
            const date = Math.floor(Date.now() / 1000);
            marketTimeInSeconds = date * 1000;
            // 创建日期对象
            marketTimeInSeconds = new Date(marketTimeInSeconds);
          } else {
            marketTimeInSeconds = parseInt(
              new Date(productData.market_time).getTime()
            );
          }

          Object.assign(this.shelfGoodsRuleForm, {
            productClass: productData.productClass,
            market_time_new: marketTimeInSeconds,
            yearSale: productData.yearSale,
            retail_price: productData.retail_price,
            sales_channel: productData.sales_channel,
            expand_channels: productData.expand_channels,
            introduction: productData.introduction,
            used_dosage: productData.used_dosage,
            used_dosagearr: productData.used_dosage.split(","),
            up_suggest: productData.up_suggest,
            up_suggest1: productData.up_suggest,
            is_import: productData.is_import,
            imgs: productData.imgs.split(","),
          });
          let new_up_suggest = [];
          for (const key in this.dictData.up_suggest) {
            this.dictData.up_suggest.map((item) => {
              new_up_suggest.push(item);
            });
          }
          this.shelfGoodsRuleForm.up_suggestarr =
            this.shelfGoodsRuleForm.up_suggestarr.filter(
              (item) =>
                new Set(new_up_suggest).has(item) ||
                this.startsWithHash(item) ||
                item === "其他"
            );

          // 可生产剂型
          this.shelfGoodsRuleForm.used_dosagearr =
            this.shelfGoodsRuleForm.used_dosagearr.filter(
              (item) =>
                new Set(this.dictData.used_dosage).has(item) ||
                this.startsWithHash(item) ||
                item === "其他"
            );

          // 判断数组中是否包含以 # 开头的元素
          const hasup_sugge = this.shelfGoodsRuleForm.up_suggestarr.some(
            (item) => item.startsWith("#")
          );
          if (hasup_sugge) {
            let up_suggest_new = this.processArray(
              this.shelfGoodsRuleForm.up_suggestarr,
              additionalOptions
            );
            this.shelfGoodsRuleForm.up_suggestarr = up_suggest_new.resultArray;
            this.hjxz = up_suggest_new.extractedOptions[0];
          }
          const hasused_dosage = this.shelfGoodsRuleForm.used_dosagearr.some(
            (item) => item.startsWith("#")
          );
          if (hasused_dosage) {
            let used_dosage_new = this.processArray(
              this.shelfGoodsRuleForm.used_dosagearr,
              additionalOptions
            );
            this.shelfGoodsRuleForm.used_dosagearr =
              used_dosage_new.resultArray;
            this.scjx = used_dosage_new.extractedOptions[0];
          }
          if (productData.productClass === "OEM") {
            const solutionImages = productData.solution_image
              .split(",")
              .map((item) => ({ url: item }));

            Object.assign(this.shelfGoodsRuleForm, {
              partnership: productData.partnership,
              solution: productData.solution,
              solutionarr: productData.solution.split(","),
              hope_customer: productData.hope_customer,
              hope_customerarr: productData.hope_customer.split(","),
              provide_used_dosage: productData.provide_used_dosage,
              provide_used_dosagearr:
                productData.provide_used_dosage.split(","),
              solution_images: solutionImages,
              is_factory: productData.is_factory,
              is_overseas_factory: productData.is_overseas_factory,
              is_self_materials: productData.is_self_materials,
              provide_solution: productData.provide_solution,
              push_new_product: productData.push_new_product,
            });
            let new_solution = [];
            for (const key in this.dictData.solution) {
              this.dictData.solution[key].map((item) => {
                new_solution.push(item);
              });
            }
            this.shelfGoodsRuleForm.solutionarr =
              this.shelfGoodsRuleForm.solutionarr.filter(
                (item) =>
                  new Set(new_solution).has(item) ||
                  this.startsWithHash(item) ||
                  item === "其他"
              );

            this.shelfGoodsRuleForm.hope_customerarr =
              this.shelfGoodsRuleForm.hope_customerarr.filter(
                (item) =>
                  new Set(this.dictData.hope_customer).has(item) ||
                  this.startsWithHash(item) ||
                  item === "其他"
              );
            this.shelfGoodsRuleForm.provide_used_dosagearr =
              this.shelfGoodsRuleForm.provide_used_dosagearr.filter(
                (item) =>
                  new Set(this.dictData.provide_used_dosage).has(item) ||
                  this.startsWithHash(item) ||
                  item === "其他"
              );

            // 判断数组中是否包含以 # 开头的元素
            const hassolutionarr = this.shelfGoodsRuleForm.solutionarr.some(
              (item) => item.startsWith("#")
            );
            if (hassolutionarr) {
              let solution_new = this.processArray(
                this.shelfGoodsRuleForm.solutionarr,
                additionalOptions
              );
              this.shelfGoodsRuleForm.solutionarr = solution_new.resultArray;
              this.jjfa = solution_new.extractedOptions[0];
            }
            const hashope_customer =
              this.shelfGoodsRuleForm.hope_customerarr.some((item) =>
                item.startsWith("#")
              );
            if (hashope_customer) {
              let hope_customer_new = this.processArray(
                this.shelfGoodsRuleForm.hope_customerarr,
                additionalOptions
              );
              this.shelfGoodsRuleForm.hope_customerarr =
                hope_customer_new.resultArray;
              this.khlx = hope_customer_new.extractedOptions[0];
            }
            const hasprovide_used_dosage =
              this.shelfGoodsRuleForm.provide_used_dosagearr.some((item) =>
                item.startsWith("#")
              );
            if (hasprovide_used_dosage) {
              let provide_used_dosage_new = this.processArray(
                this.shelfGoodsRuleForm.provide_used_dosagearr,
                additionalOptions
              );
              this.shelfGoodsRuleForm.provide_used_dosagearr =
                provide_used_dosage_new.resultArray;
              this.cpxt = provide_used_dosage_new.extractedOptions[0];
            }
          }

          if (this.type == 2) {
            this.shelfGoodsRuleForm.match_making =
              productData.match_making.split(",");
          }

          this.$forceUpdate();
        }
      } catch (err) {
        console.error("Error fetching product details:", err);
      }
    },

    // 判断是否pdf
    isPDF(url) {
      if (!url) {
        return false;
      }
      const fileType = ["pdf"];
      const index = url.lastIndexOf(".");
      const type = url.substr(index + 1);
      return fileType.indexOf(type) > -1;
    },
    //预览图片
    handlePreview(file) {
      if (file.fileType == "pdf") {
        window.open(file.url, "_blank");
      } else {
        console.log(file.url);

        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }
    },
    // 产品详情
    //  productDetail(){
    //       axios.post('api.php?m=nhneProduct.getDetail&v=3.0',qs.stringify({
    //          id:'5'
    //      })).then(res => {
    //              if(res.status == 200){
    //                  let data=res.data.rst;
    //                  this.data=data

    //                  if(data.burdenImg){
    //                      let imgs=JSON.parse(data.burdenImg)
    //                      let newimgs=[]
    //                      let jkimgs=[]
    //                      imgs.map(item=>{

    //                          if(this.isPDF(this.Imghttp+item)){

    //                                newimgs.push({url:this.Imghttp+item,fileType:'pdf'})
    //                          }else{

    //                              newimgs.push({url:this.Imghttp+item,fileType:'image'})

    //                          }

    //                      })
    //                      this.cpFileList=newimgs
    //                  }

    //                   if(data.imgs){
    //                      let imgs=JSON.parse(data.imgs)
    //                      let newimgs=[]
    //                      let jkimgs=[]
    //                      imgs.map(item=>{
    //                          newimgs.push({url:this.Imghttp+item})

    //                      })
    //                      this.cpImgsFileList=newimgs
    //                  }

    //                    if(data.inspectionReport){
    //                      let imgs=JSON.parse(data.inspectionReport)
    //                      let newimgs=[]
    //                      let jkimgs=[]
    //                      imgs.map(item=>{
    //                          if(this.isPDF(this.Imghttp+item)){

    //                                newimgs.push({url:this.Imghttp+item,fileType:'pdf'})
    //                          }else{

    //                              newimgs.push({url:this.Imghttp+item,fileType:'image'})

    //                          }
    //                      })
    //                      this.zjImgsFileList=newimgs

    //                  }

    //                   if(data.productPatent){
    //                      let imgs=JSON.parse(data.productPatent)
    //                      let newimgs=[]
    //                      let jkimgs=[]
    //                      imgs.map(item=>{
    //                          if(this.isPDF(this.Imghttp+item)){

    //                                newimgs.push({url:this.Imghttp+item,fileType:'pdf'})
    //                          }else{

    //                              newimgs.push({url:this.Imghttp+item,fileType:'image'})

    //                          }
    //                      })
    //                      this.fmImgsFileList=newimgs

    //                  }

    //                  if(data.historyAward){
    //                      let imgs=JSON.parse(data.historyAward)
    //                      let newimgs=[]
    //                      let jkimgs=[]
    //                      imgs.map(item=>{
    //                           if(this.isPDF(this.Imghttp+item)){

    //                                newimgs.push({url:this.Imghttp+item,fileType:'pdf'})
    //                          }else{

    //                              newimgs.push({url:this.Imghttp+item,fileType:'image'})

    //                          }
    //                      })
    //                      this.lsImgsFileList=newimgs
    //                  }
    //              }
    //          })
    //          .catch(function (err) {
    //              console.log(err);
    //          });
    //  },
    // 跳转添加&修改页面
    tapForm(id) {
      window.location.href = "<?= URL('discussion.productawardForm'); ?>";
    },
    // 跳转详情
    tapdetail() {
      window.location.href = "<?= URL('discussion.productawardDetail'); ?>";
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.img-tips {
  color: red;
}
.image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;
  display: inline-block;
  /deep/ .el-image {
    width: 148px;
    height: 148px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    .el-image__inner {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;
    border-radius: 6px;
    .upload-icon {
      color: #fff !important;
      font-size: 22px !important;
    }
  }
  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}
body {
  background: #fff;
}
.content {
  background: #fff;
  margin-right: 40px;
}
/*评奖报名首页*/
.main {
  padding: 30px 0px 30px 40px;
  box-sizing: border-box;
}
.main .title {
  color: #000;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  font-family: SourceHanSansCN, SourceHanSansCN;
}
.main .dis-notice {
  color: #000;
  padding: 20px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 22px;
  border-radius: 8px;
  background: #f8f8f8;
  margin: 20px 0 52px;
  font-family: PingFangSC, PingFang SC;
}
.main .dis-notice p {
  max-width: 730px;
}
.main .dis-notice .seek {
  font-size: 16px;
  line-height: 24px;
  padding-top: 15px;
}
.main .dis-list .dis-item {
  width: 44%;
  height: 162px;
  max-width: 510px;
  min-width: 430px;
  margin-right: 30px;
  margin-bottom: 30px;
  background: #f6f7fc;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 31px 20px 20px;
  font-size: 14px;
  color: #000;
  line-height: 20px;
  position: relative;
  font-family: PingFangSC, PingFang SC;
}
.main .dis-list .dis-item-left .dis-title {
  font-size: 24px;
  font-weight: 500;
  line-height: 33px;
}
.main .dis-list .dis-item-left .dis-time {
  font-size: 20px;
  padding: 15px 0;
  line-height: 28px;
}
.main .dis-list .dis-item-left .dis-more a {
  color: #999;
  display: flex;
  align-items: center;
}
.main .dis-list .dis-item-left .dis-more .more-img {
  width: 17px;
}
.main .dis-list .dis-item .sign-tips {
  width: 116px;
  height: 39px;
  color: #ff0000;
  font-size: 18px;
  text-align: center;
  line-height: 39px;
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(
    180deg,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0.2) 100%
  );
  border-radius: 8px 8px 8px 26px;
}
.main .dis-list .dis-item-right .dis-btn {
  width: 128px;
  height: 44px;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  line-height: 44px;
  text-align: center;
  background: #fc9749;
  border-radius: 8px;
  border: 1px solid #fc9749;
  font-family: PingFangSC, PingFang SC;
}
.main .dis-list .dis-item-right .dis-ebtn {
  color: #fc9749;
  background: #fff;
  border: 1px solid #fc9749;
}

/*奖项详情*/
.main-details .details-top {
  height: 78px;
  padding: 0 40px;
  font-size: 18px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  color: #000;
  background: #f3f4f8;
}
.main-details .details-top .close-btn {
  width: 130px;
  height: 44px;
  color: #666;
  font-size: 14px;
  line-height: 44px;
  text-align: center;
  background: #fff;
  border-radius: 8px;
  cursor: pointer;
}
.main-details .details-title {
  color: #3d83e8;
  font-size: 16px;
  padding-top: 20px;
  line-height: 24px;
  margin-left: 40px;
  padding-bottom: 10px;
  font-family: PingFangSC, PingFang SC;
  border-bottom: 1px solid #3d83e9;
}
.main-details .details-content {
  padding: 20px;
  margin: 20px 40px;
  background: #f8f8f8;
  border-radius: 8px;
}

/*品牌企业奖——信息填写*/
.content_main .content-notice {
  padding: 20px;
  font-size: 14px;
  color: #000;
  line-height: 22px;
  min-height: 106px;
  background: #f8f8f8;
  border-radius: 8px;
  margin-right: 38px;
  margin-bottom: 20px;
  box-sizing: border-box;
  font-family: PingFangSC, PingFang SC;
}
.save_btn .el-button {
  width: 130px;
}
/*.demo-ruleForm .el-form-item{*/
/*    padding-right: 30px;*/
/*}*/
/*.demo-ruleForm .el-form-item__label{*/
/*    padding: 0;*/
/*    color: #000;*/
/*    font-size: 16px;*/
/*    line-height: 35px;*/
/*    font-family: PingFangSC, PingFang SC;*/
/*}*/
.awards-upload .el-upload--picture-card,
.awards-upload .el-upload--picture-card .upload-tip,
.awards-upload .el-upload-list--picture-card .el-upload-list__item {
  width: 262px;
  height: 128px;
}
.awards-upload .el-upload--picture-card {
  background: #fff;
}
.awards-upload .el-upload--picture-card .upload-tip i {
  padding-top: 20px;
  display: inline-block;
}
.awards-upload .el-upload--picture-card .upload-tip .upload-img {
  width: 34px;
  height: 34px;
  display: block;
  margin: 0 auto 15px;
}
.awards-upload .el-upload--picture-card .upload-tip .tips {
  width: 100%;
  height: 24px;
  color: #000;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item {
  position: relative;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  height: auto;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.pdf_box {
  width: 358px;
  height: 68px;
  background: #ffffff;
  border-radius: 8px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
}
.pdf_box img {
  width: 28px;
  height: 28px;
}
.txt_box {
  margin: 0 58px 0 10px;
}
.txt_title {
  width: 173px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 13px;
  color: #000000;
  line-height: 24px;
}
.txt_size {
  width: 39px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 24px;
}
.xz_btn {
  width: 54px;
  height: 26px;
  line-height: 26px;
  background: #e4efff;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #3d83e9;
  text-align: center;
  cursor: pointer;
}

/*产品评奖详情页面*/
body {
  background: #fff !important;
}

.main {
}
.header_title {
  font-size: 18px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 400;
}
.header_main {
  background: #f3f4f8;
  padding: 30px 38px;
  box-sizing: border-box;
}
.content_main {
  padding: 30px 0;
  box-sizing: border-box;
}
.content_main_title {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #3d83e8;
  padding-bottom: 10px;
  border-bottom: 1px solid #3d83e9;
  margin-bottom: 20px;
}
.product_title {
  margin: 0 0 24px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #000000;
}
.content_main .el-row {
  margin-bottom: 20px;
}

.content_main .el-row span:nth-child(1) {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #777777;
}
.content_main .el-row span:nth-child(2) {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}
.demo-ruleForm .el-form-item {
  padding-right: 30px;
}
.img_detail {
  width: 120px;
  height: 120px;
  margin-right: 10px;
}
.img_box {
  display: flex;
}
.save_btn {
  display: flex;
  justify-content: center;
  margin-top: 162px;
}
@media only screen and (max-width: 767px) {
  .el-col-12 {
    width: 100%;
  }
  .el-col-8 {
    width: 100%;
  }
}
</style>
<style >
.el-radio-group {
  font-size: 12px !important;
  line-height: 3 !important;
}
</style>